<app-page-bar></app-page-bar>

<app-page>

  <section *ngIf="partner">

    <mat-card class="app-card">
      <div class="title">
        <h2>{{partner.isNew() ? "New Seller" : partner.name }}</h2>
        <h3>Seller</h3>
        <p class="small" *ngIf="!partner.isNew()">Created {{partner.created|date}}</p>
      </div>
    </mat-card>

    <mat-card class="app-card">
      <div class="header">
        <h3>Information</h3>
      </div>
      <form [formGroup]="form" id="seller-form" (ngSubmit)="savePartner()" novalidate>
        <div class="form-grid">
          <mat-form-field floatLabel="never">
            <input matInput placeholder="Name" formControlName="name" [readonly]="!editMode" appAutofocus/>
          </mat-form-field>
        </div>
        <div class="actions">
          <button type="button" mat-button color="primary" *ngIf="!editMode" (click)="editPartner()">Edit</button>
          <button type="submit" mat-button color="primary" *ngIf="editMode" form="seller-form" [disabled]="!form.valid">Save</button>
          <button type="reset" mat-button *ngIf="editMode" (click)="revertPartner()">Cancel</button>
        </div>
      </form>
    </mat-card>

  </section>

</app-page>
